import React from 'react'
import PropTypes from 'prop-types'
import { Card, Text, Heading, Image, Box } from '@chakra-ui/react'

const RenderEmpCard = props => {
	const {
		imgSrc,
		OrgName,
		empImage,
		empName,
		empDesignation,
		empDept,
		orgColor,
	} = props
	return (
		<Card className='empCard' bg='white' variant='filled' align='center'>
			<div className='empCardtag' />
			<Box className='empOrgDiv' bg={orgColor}>
				<Image
					src={imgSrc}
					alt='emp image'
					w='36px'
					h='32px'
					mr='10px'
					filter='brightness(0) invert(1)'
				/>
				<Text
					fontWeight='900'
					fontSize='1rem'
					lineHeight='1.375rem'
					color='white'
				>
					{OrgName}
				</Text>
			</Box>
			<Image
				src={empImage}
				alt='emp image'
				boxSize='205px'
				className='empImage'
			/>
			<div className='empDetails'>
				<Heading size='md' color='#ED2736' align='center'>
					{empName}
				</Heading>
				<Text
					className='description'
					fontSize='sm'
					color='black'
					align='center'
				>
					{empDesignation}
				</Text>
				<Text
					className='description'
					fontSize='sm'
					color='black'
					align='center'
				>
					{empDept}
				</Text>
			</div>
		</Card>
	)
}

RenderEmpCard.propTypes = {
	imgSrc: PropTypes.string,
	OrgName: PropTypes.string,
	empDesignation: PropTypes.string,
	empImage: PropTypes.string,
	empName: PropTypes.string,
	empDept: PropTypes.string,
}

export { RenderEmpCard }
